import { getTextDecorationThickness as getGlobalTextDecorationThickness } from './global';
import { INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, } from '../../../../constants';
export function getTextDecorationThickness(transformer) {
    const globalTextDecorationThickness = getGlobalTextDecorationThickness(transformer);
    return Object.freeze({
        link: {
            primary: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.l },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.l },
                },
            },
            primaryStrong: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.l },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.l },
                },
            },
            primaryStandAlone: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.l },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.l },
                },
            },
            primaryStandAloneStrong: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.l },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.l },
                },
            },
            secondary: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.m },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.m },
                },
            },
            secondaryStrong: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.m },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.m },
                },
            },
            secondaryStandAlone: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.m },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.m },
                },
            },
            secondaryStandAloneStrong: {
                default: { value: globalTextDecorationThickness.m },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalTextDecorationThickness.m },
                    [INTERACTION_STATE_ACTIVE]: { value: globalTextDecorationThickness.m },
                },
            },
            info: {
                default: { value: globalTextDecorationThickness.m },
            },
        },
    });
}
